<template>
<div>

    <!-- STANDARD VERSION -->
    <!--<div v-if="isStandardSurvey">
        <div v-if="qId === '6' || qId === '15'" class="clearfix buttons-container">
            <v-btn
            class="button"
            color="primary"
            dark
            min-width="300px"
            @click="onFillZerosWithSubs(myAnswer)"
            >Fill empty fields with zeroes</v-btn>
        </div>
        <div v-else-if="qId === '7' || qId === '8' || qId === '9'" class="clearfix buttons-container">
            <v-btn
            class="button"
            color="primary"
            dark
            min-width="300px"
            @click="onFillZerosWithoutSubs(myAnswer)"
            >Fill empty fields with zeroes</v-btn>
        </div>
        <div v-else-if="qId === '11' || qId === '16' || qId === '17'" class="clearfix buttons-container">
            <v-btn
            class="button"
            color="primary"
            dark
            min-width="300px"
            @click="onFillZerosEntities2(myAnswer)"
            >Fill empty fields with zeroes</v-btn>
        </div>
    </div>-->

    <!-- DOD VERSION -->
    <!--<div v-else-if="!isStandardSurvey">
        <div v-if="qId === '7' || qId === '17'" class="clearfix buttons-container">
            <v-btn
            class="button"
            color="primary"
            dark
            min-width="300px"
            @click="onFillZerosWithSubs(myAnswer)"
            >Fill empty fields with zeroes</v-btn>
        </div>
        <div v-else-if="qId === '8' || qId === '9' || qId === '10'" class="clearfix buttons-container">
            <v-btn
            class="button"
            color="primary"
            dark
            min-width="300px"
            @click="onFillZerosWithoutSubs(myAnswer)"
            >Fill empty fields with zeroes</v-btn>
        </div>
        <div v-else-if="qId === '12'" class="clearfix buttons-container">
            <v-btn
            class="button"
            rounded
            color="primary"
            dark
            min-width="300px"
            @click="onFillZerosTest(myAnswer)"
            >Fill empty fields with zeroes</v-btn>
        </div>
        <div v-else-if="qId === '12' || qId === '13' || qId === '14'" class="clearfix buttons-container">
            <v-btn
            class="button"
            color="primary"
            dark
            min-width="300px"
            @click="onFillZerosEntities2(myAnswer)"
            >Fill empty fields with zeroes</v-btn>
        </div>
        <div v-else-if="qId === '15'" class="clearfix buttons-container">
            <v-btn
            class="button"
            color="primary"
            dark
            min-width="300px"
            @click="onFillZerosEntities(myAnswer)"
            >Fill empty fields with zeroes</v-btn>
        </div>
    </div>-->
</div>
</template>

<script>
import { answerService } from "../../services/answerService";
import { utilityService } from "../../services/utilityService";
import { CONSTANTS } from "../../common/constants";
export default {
    name: "ButtonFillZeros",
    props: {
        layout: Object,
        qId: String,
        checkError: Boolean,
        columns: Array,
        isStandardSurvey: Boolean
    },
    data: () => ({
        myMatrix: null,
        myAnswer: null,
        myProps: null,
        myColumns: null,
        qColumns: [],
        myRows: null
    }),
    watch: {
        layout: function (newVal, oldVal) {
            if (newVal) {
                this.myMatrix = this.layout.matrix;
                this.myRows =
                !this.myMatrix.rows || this.myMatrix.rows.length === 0
                    ? this.myMatrix
                    : this.myMatrix.rows;
                this.myAnswer = this.layout.answer;
                this.myProps = this.layout.props;
                this.myColumns = this.layout.columns;
            }
        },
        columns: function (newVal, oldVal) {
        this.qColumns = newVal;
        }
    },
    methods: {

        onFillZerosEntities2: function () {
            var cell_name;
            const numCategories = this.myRows.length;

            for (var i = 0; i < numCategories; i++) {
                // Contains subcategories
                if (this.myRows[i].hasOwnProperty('subs')) {
                    const numSubcategories = this.myRows[i].subs.length;
                    // console.log('num subcategories for category(' + i + ') = ' + this.myRows[i].subs.length);
                    for (var j = 0; j < numSubcategories; j++) {
                        const num_columns = this.qColumns.length;
                        for (var k = 0; k < num_columns; k++) {
                            cell_name = this.myRows[i].subs[j].answers[k].cellId.substr(0, this.myRows[i].subs[j].answers[k].cellId.indexOf('_'));
                            // console.log('Cell Name for row(' + i + ') sub(' + j + ') col(' + k + ') = ' + cell_name);

                            if (!this.myAnswer[i][cell_name]) {
                            this.myAnswer[i][cell_name] = 0;
                            }
                        }
                    }
                }
                // Doesn't contain subcategories
                else {
                    const num_columns = this.qColumns.length;
                    for (var k = 0; k < num_columns; k++) {
                        console.log('test = ' + JSON.stringify(this.myRows[i].answers[k]));
                        cell_name = this.myRows[i].answers[k].cellId.substr(0, this.myRows[i].answers[k].cellId.indexOf('_'));
                        // console.log('Cell Name for row(' + i + ') col(' + k + ') = ' + cell_name);

                        if (!this.myAnswer[i][cell_name]) {
                            this.myAnswer[i][cell_name] = 0;
                        }
                    }
                }
            }
        },

        onFillZerosCountries: function () {
            var cell_name;
            const numCategories = this.myRows.length;
            const numRows = this.myAnswer.length;

            // console.log('num categories = ' + this.myRows.length);
            // console.log('num rows = ' + this.myAnswer.length);
            // console.log('num cols = ' + this.qColumns.length);

            for (var i = 0; i < numRows; i++) {
                const num_columns = this.qColumns.length;
                for (var k = 0; k < num_columns; k++) {
                    console.log('test = ' + JSON.stringify(this.myRows[0].answers[k]));
                    cell_name = this.myRows[0].answers[k].cellId.substr(0, this.myRows[0].answers[k].cellId.indexOf('_'));
                    console.log('Cell Name for row(' + i + ') col(' + k + ') = ' + cell_name);

                    if (!this.myAnswer[i][cell_name]) {
                        this.myAnswer[i][cell_name] = 0;
                    }
                }
            }
        },

        onFillZerosEntities: function () {
            var cell_name;
            const numCategories = this.myRows.length;

            // console.log('num categories = ' + this.myRows.length);
            // console.log('num cols = ' + this.qColumns.length);

            for (var i = 0; i < numCategories; i++) {
                // Contains subcategories
                if (this.myRows[i].hasOwnProperty('subs')) {
                    // const numSubcategories = this.myRows[i].subs.length;
                    // console.log('num subcategories for category(' + i + ') = ' + this.myRows[i].subs.length);
                    for (var j = 0; j < numSubcategories; j++) {
                        const num_columns = this.qColumns.length;
                        for (var k = 0; k < num_columns; k++) {
                            cell_name = this.myRows[i].subs[j].answers[k].cellId.substr(0, this.myRows[i].subs[j].answers[k].cellId.indexOf('_'));
                            // console.log('Cell Name for row(' + i + ') sub(' + j + ') col(' + k + ') = ' + cell_name);

                            if (!this.myAnswer[i][cell_name]) {
                            this.myAnswer[i][cell_name] = 0;
                            }
                        }
                    }
                }
                // Doesn't contain subcategories
                else {
                    const num_columns = this.qColumns.length;
                    for (var k = 0; k < num_columns; k++) {
                        // console.log('test = ' + JSON.stringify(this.myRows[i].answers[k]));
                        cell_name = this.myRows[i].answers[k].cellId.substr(0, this.myRows[i].answers[k].cellId.indexOf('_'));
                        // console.log('Cell Name for row(' + i + ') col(' + k + ') = ' + cell_name);

                        if (!this.myAnswer[i][cell_name]) {
                            this.myAnswer[i][cell_name] = 0;
                        }
                    }
                }
            }
        },

        onFillZerosWithoutSubs: function () {
            var cell_name;
            const numCategories = this.myRows.length;

            // console.log('num categories = ' + this.myRows.length);
            // console.log('num cols = ' + this.qColumns.length);

            for (var i = 0; i < numCategories; i++) {
                const num_columns = this.qColumns.length;
                for (var k = 0; k < num_columns; k++) {
                    cell_name = this.myRows[i].answers[k].cellId.substr(0, this.myRows[i].answers[k].cellId.indexOf('_'));
                    // console.log('cell name = ' + cell_name);
                    // console.log('Cell Name for row(' + i + ') col(' + k + ') = ' + cell_name);

                    // var category_letter = answerCategories[i];
                    // console.log('category_letter = ' + category_letter);
                    // console.log('myAnswer cell name' + this.myAnswer[0][category_letter][cell_name]);
                    // console.log('My Answer whole obj = ' +  JSON.stringify(this.myAnswer) );
                    // console.log('Answer for field = ' +  this.myAnswer[0][cell_name] );

                    if (!this.myAnswer[0][cell_name]) {
                        // console.log('IF = TRUE...Field: ' + this.myAnswer[0][cell_name] + ' = 0');
                        this.$set(this.myAnswer[0], [cell_name], 0);
                        // this.myAnswer.push();
                    }
                }
            }
        },

        onFillZerosWithSubs: function () {
            var cell_name;
            const numCategories = this.myRows.length;

            // console.log('num categories = ' + this.myRows.length);
            // console.log('num cols = ' + this.qColumns.length);

            for (var i = 0; i < numCategories; i++) {
                // Contains subcategories
                if (this.myRows[i].hasOwnProperty('subs')) {
                    const numSubcategories = this.myRows[i].subs.length;
                    // console.log('num subcategories for category(' + i + ') = ' + this.myRows[i].subs.length);
                    for (var j = 0; j < numSubcategories; j++) {
                        const num_columns = this.qColumns.length;
                        for (var k = 0; k < num_columns; k++) {
                            cell_name = this.myRows[i].subs[j].answers[k].cellId.substr(0, this.myRows[i].subs[j].answers[k].cellId.indexOf('_'));
                            // console.log('Cell Name for row(' + i + ') sub(' + j + ') col(' + k + ') = ' + cell_name);

                            if (!this.myAnswer[0][this.myRows[i].header][cell_name]) {
                            this.myAnswer[0][this.myRows[i].header][cell_name] = 0;
                            // this.myAnswer.push();
                            }
                        }
                    }
                }
                // Doesn't contain subcategories
                else {
                    const num_columns = this.qColumns.length;
                    for (var k = 0; k < num_columns; k++) {
                        cell_name = this.myRows[i].answers[k].cellId.substr(0, this.myRows[i].answers[k].cellId.indexOf('_'));
                        // console.log('Cell Name for row(' + i + ') col(' + k + ') = ' + cell_name);

                        if (!this.myAnswer[0][this.myRows[i].header][cell_name]) {
                            this.myAnswer[0][this.myRows[i].header][cell_name] = 0;
                            // this.myAnswer.push();
                        }
                    }
                }
            }
        }
    }
};
</script>

<style scoped>
.column-header {
  text-align: center;
  font-weight: bold;
}
</style>
